"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BounceAbilityHandler = exports.BounceActorAbilityFactory = exports.BounceAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class BounceAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Bounce;
        this.__typeName = "Bounce";
    }
}
exports.BounceAbilityArgs = BounceAbilityArgs;
let BounceActorAbilityFactory = class BounceActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Bounce", "OneEnemies", 2);
    }
};
BounceActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Bounce")
], BounceActorAbilityFactory);
exports.BounceActorAbilityFactory = BounceActorAbilityFactory;
let BounceAbilityHandler = class BounceAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targets: [
                {
                    targetId,
                    damages: [
                        AbilityDamage_1.AbilityDamage.Power("Chaos", 120)
                    ],
                    effects: [
                        {
                            targetId,
                            duration: Duration_1.Duration.Turns(1),
                            effect: new core_1.StunEffectArgs,
                            supernatural: true,
                        },
                        {
                            targetId,
                            duration: Duration_1.Duration.Instant,
                            effect: new core_1.TurnMeterDecreaseEffectArgs(container.getTurnMeter(targetId), false),
                            supernatural: true
                        }
                    ]
                }
            ]
        });
    }
};
BounceAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Bounce)
], BounceAbilityHandler);
exports.BounceAbilityHandler = BounceAbilityHandler;
